import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { signoutUser, beelineText } from '../actions';
import Avatar from '../assets/dashboard/avatar.svg';

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPage: this.props.defaultPage,
    };
  }

  componentDidMount() {
    this.props.beelineText();
  }

  componentDidUpdate() {
    this.props.beelineText();
  }

  handleClick = (page) => {
    this.setState({ selectedPage: page });
  }

  render() {
    return (
      <div className="dashboard-nav-container">
        <img src={Avatar} alt="avatar" />
        <NavLink
          to="/dashboard"
          onClick={() => this.handleClick('home')}
        >
          <p
            className={this.state.selectedPage === 'home' ? 'active-sidebar-text' : null}
          >Home
          </p>
        </NavLink>
        <NavLink
          to="/dashboard/allsurveys"
          onClick={() => this.handleClick('all')}
        >
          <p
            className={this.state.selectedPage === 'all' ? 'active-sidebar-text' : null}
          >All Toolkits
          </p>
        </NavLink>
        <NavLink
          to="/dashboard/favorites"
          onClick={() => this.handleClick('favorites')}
        >
          <p
            className={this.state.selectedPage === 'favorites' ? 'active-sidebar-text' : null}
          >Favorite Tools
          </p>
        </NavLink>
        <NavLink
          to="/dashboard/account"
          onClick={() => this.handleClick('account')}
        >
          <p
            className={this.state.selectedPage === 'account' ? 'active-sidebar-text' : null}
          >Account
          </p>
        </NavLink>
        <div
          className="no-out"
          role="button"
          tabIndex={0}
          onClick={() => { this.props.signoutUser(this.props.hist); }}
        >
          <p>Log Out</p>
        </div>
      </div>
    );
  }
}

export default connect(null, { signoutUser, beelineText })(SideBar);
